export default "<p>access-denied works!</p>\n<div class=\"base io\">\n<h1 class=\"io\">403</h1>\n<h2>Access forbidden</h2>\n\n</div>\n\n"